import { useNavigate } from "react-router-dom";

import { Button, Checkbox, Spin, message } from "antd";
import React, { useEffect, useState } from "react";

import LegalContent from "@/components/common/LegalContent";
import { ROUTES_URL } from "@/constant";
import styles from "@/pages/Terms/Terms.module.css";
import { acceptTermsConditions, getLastestTerms } from "@/services/Auth/AuthApi";
import { useAuthStore } from "@/stores/authStore";

const Terms: React.FC = () => {
  const navigate = useNavigate();
  const { updateState, isTCAccepted } = useAuthStore();
  const [acceptChecked, setAcceptChecked] = useState(false);
  const [latestTerms, setLatestTerms] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const fetchTerms = async (): Promise<void> => {
    try {
      setLoading(true);
      const res = await getLastestTerms();
      setLatestTerms(res?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (): Promise<void> => {
    try {
      if (!acceptChecked) {
        message.error("Please accept Terms & Conditions to continue");
        return;
      }
      setLoading(true);
      await acceptTermsConditions({
        tnc_id: latestTerms?.id,
      });
      message.success("Terms and Conditions accepted successfully");
      updateState({ isTCAccepted: true });
      navigate(ROUTES_URL.DASHBOARD);
    } catch (error: unknown) {
      // if (axios.isAxiosError<{ message: string }>(error)) {
      //   message.error(error?.response?.data?.message || "Reset failed");
      // }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void fetchTerms();
  }, []);

  return (
    <Spin spinning={loading}>
      <div className={styles.gradientBg}>
        <div>
          <div className={!isTCAccepted ? styles.container : styles.fullContainer}>
            <h1 className={styles.title}>Terms and Conditions</h1>

            <div className={!isTCAccepted ? styles.list : styles.fullList}>
              <LegalContent html={latestTerms?.meta_data || ""} />
            </div>
          </div>
          {!isTCAccepted ? (
            <>
              <Checkbox
                checked={acceptChecked}
                onChange={(e) => setAcceptChecked(e.target.checked)}
                className="mt-10"
              >
                Accept Terms & Conditions
              </Checkbox>
              <div className="flex justify-end">
                <Button
                  htmlType="submit"
                  className={styles.applyButton}
                  loading={loading}
                  onClick={onFinish}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <div className={styles.backToLogin}>
              <Button
                htmlType="submit"
                className={styles.applyButton}
                onClick={() => navigate(ROUTES_URL.LOGIN)}
              >
                Back to Login
              </Button>
            </div>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default Terms;
